import React from 'react'
import Icon from '../../assets/icons/icon-differentials-ex.webp'
import Arrow from '../../assets/icons/icon-arrow-up.svg'
import { Suspense, useEffect, useState } from 'react'
import clsx from 'clsx'
import SkeletonLoading from '../common/SkeletonLoading'
import { v4 } from 'uuid'
import { strToSlug } from '../../common_functions'
import enterpriseApi from '../../store/reducers/enterprise/enterpriseApi'

export interface Props {
  EnterpriseId: string
}
export default function FinancingConditions({ EnterpriseId }: Props) {
  const [hiddenContent, setHiddenContent] = useState(true)
  const { data, isError, isSuccess, isLoading } =
    enterpriseApi.useGetEnterprisePaymentConditionByIdQuery(EnterpriseId ?? '')

  return (
    <>
      {(isLoading) && <SkeletonLoading height={200} />}
      {isSuccess && data?.Data.length > 0 && (
        <>
          <section
            className="border border-gray-200 rounded-xl p-4"
            id={'navInternEnterpriseFinancingConditions'}
          >
          <h3 className='text-lg text-[#4D4D4D] fw-semibold'>Condições de Financiamento</h3>
            {/* CONTENT */}
            <div
             className='mt-2'>
              <>
                {data?.Data?.map((item) => {
                  return (
                    <div
                      key={`${strToSlug(item.Id)}`}
                      className="rounded-2xl p-2 m-2 inline-flex w-fit border-1 border-[#0059FF]"
                    >
                      <h5 className="text-base text-[#0059FF] fw-normal">{item.PaymentCondition.Name}</h5>
                    </div>
                  )
                })}
              </>
            </div>
          </section>
        </>
      )}
    </>
  )
}
